import React from "react";
import { useNavigate } from "react-router-dom";
import { css } from "@emotion/react";

const containerStyles = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #141414;
  color: #ffffff;
  padding: 24px;
`;

const cardStyles = css`
  width: 100%;
  max-width: 560px;
  padding: 24px;
  border-radius: 14px;
  background: linear-gradient(180deg, #181818, #121212);
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.03);
`;

const sectionStyles = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const labelStyles = css`
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.95rem;
`;

const linkStyles = css`
  color: #a855f7;
  text-decoration: none;
  font-weight: 600;
  margin-bottom: 16px;
  &:hover {
    text-decoration: underline;
  }
`;

const paragraphStyles = css`
  color: #e0e0e0;
  line-height: 1.7;
`;

export default function SupportPage() {
  const navigate = useNavigate();

  return (
    <div css={containerStyles}>
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          navigate("/settings");
        }}
        css={linkStyles}
      >
        ← Back to Settings
      </a>

      <div css={cardStyles}>
        <div css={sectionStyles}>
          <div>
            <div css={labelStyles}>Customer support</div>
            <p css={paragraphStyles}>
              For assistance, please email us at {" "}
              <a href="mailto:support@mrble.ai" css={linkStyles}>
                support@mrble.ai
              </a>
              .
            </p>
          </div>

          <div>
            <div css={labelStyles}>Bugs and feature requests</div>
            <p css={paragraphStyles}>
              To report a bug or request a feature, you can also post on our
              feedback board at {" "}
              <a
                href="https://sharpana.supahub.com"
                target="_blank"
                rel="noopener noreferrer"
                css={linkStyles}
              >
                sharpana.supahub.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
